import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross";
import React from "react";

const DetailJobModal = ({ setShowModal, data }) => {
    return (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-[50%] my-5 mx-auto ">
                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">جزئیات شغل</p>
                            <button onClick={() => setShowModal(false)} aria-label="Close">
                                <Cross />
                            </button>
                        </div>

                        <div className="w-full mt-[23px] mb-[43px] max-h-[55vh] overflow-y-auto text-[13px] text-mainColor2">
                            <p><b>عنوان:</b> {data.title}</p>
                            <p className="mt-2"><b>شرکت:</b> {data.company || "—"}</p>
                            <p className="mt-2"><b>موقعیت:</b> {data.location || "—"}</p>
                            <p className="mt-2"><b>پورتال:</b> {data.portal || "—"}</p>
                            <p className="mt-2"><b>ایمیل تماس:</b> {data.contactEmail || "—"}</p>
                            <p className="mt-2"><b>لینک:</b> {data.url ? <a href={data.url} target="_blank" rel="noreferrer" className="text-blue-500" dir="ltr">{data.url}</a> : "—"}</p>
                            <p className="mt-2"><b>کاربر:</b> {data.userName} {data.userFamily} ({data.userEmail})</p>
                            <p className="mt-2"><b>تگ‌ها:</b> {data.tagsCsv || "—"}</p>
                            <p className="mt-2"><b>مهلت:</b> {data.deadline ? new Date(data.deadline).toLocaleString("en-GB") : "—"}</p>
                            <p className="mt-2"><b>تعداد درخواست‌ها:</b> {data.jobApplyCount}</p>
                        </div>

                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)} className="h-[40px] w-[107px] bg-infinity-gradient rounded-[10px]">
                                <p className="text-[15px] text-white font-IRANYekanBold">بستن</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    );
};

export default DetailJobModal;